import React from 'react';
import ScrollTo from '../../Utils/ScrollTo.js';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Share from '@material-ui/icons/Share';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/icons/Menu';

const style = {
  selected: {
    backgroundColor: "turquoise !important",
    color: "white",
    fontWeight: 600
  }
};


export default class Chapter extends React.Component {

  state = {
    current: false,
    clicked: false
  }
  
  componentDidMount() {
    if(window.sdk.live.getCuepointById('chapter', this.props.chapter.id)) {
      this.setState({
        clicked : true  
      })
    }
  }

  setLiveCurrentChapter = (e) => {
    if(!this.props.isBroadcasting) 
      return false;
      
    window.sdk.emit('noLiveAnymore', window.sdk.live.getLastClickedCuepoint('chapter'));
    this.setCurrent(true)
    window.sdk.live.setLiveCurrent('chapter', this.props.chapter.id);
  }
  
  setCurrent(value) {
    this.setState({
      current: value,
      clicked : true  
    })  
    //this.scroll = new ScrollTo('chapter-' + this.props.chapter.id, 'tab_inner', true).go();
  }


  render() {
    let style, subStyle = {};
    let subStyleOdj1 = {
      fontWeight: 'bold'
    }
    let subStyleOdj2 = {
      color: window.theme.palette.grey['A700']
    }

    if (this.state.current) {
      style = {
        backgroundColor: window.theme.palette.primary.main,
        color: 'white'
      };
      subStyle = {
        color: 'white'
      }
      subStyleOdj1.color = 'white';
      subStyleOdj2.color = 'white';

    }

    return (
      <ListItem id={ 'chapter-' + this.props.chapter.id } button={ this.props.isBroadcasting } style={ style } selected={ this.state.current } className={ 'chapter-odj-' + this.props.chapter.odjIndex } onClick={ this.setLiveCurrentChapter }>
          <ListItemText
            disableTypography
            primary={<Typography color={(this.state.clicked ? 'primary':'inherit')} style={ subStyleOdj1 }>{ this.props.chapter.title }</Typography>}
            secondary={ <Typography style={ subStyleOdj2 }> { this.props.chapter.description } </Typography> }
          />

      </ListItem>
    );
  }

}



// WEBPACK FOOTER //
// ./src/Manager/Odj/Chapter.js